import React, { FC, ReactNode } from 'react';
import { Empty } from 'antd';

import './styles.scss';

interface ReportChartCardProps {
  children: ReactNode;
  hasData: boolean;
  title: string;
}

export const ReportChartCard: FC<ReportChartCardProps> = ({
  children,
  hasData,
  title,
}: ReportChartCardProps) => (
  <section className="prov-report-chart-card">
    <h3>{title}</h3>
    <div className="prov-report-chart-card__body">
      {hasData ? children : <Empty description="No chart data" />}
    </div>
  </section>
);
